import React, { useState } from "react";

const PatientAnalyticsModal = ({ orgCode, patientId }) => {
  return (
    <div
      style={{
        display: "flex",
        justifyContent: "center", // Centers the iframe horizontally
        alignItems: "center", // Optional: Centers the iframe vertically
        height: "100vh", // Takes full viewport height
      }}
    >
      <iframe
           src={`https://mis-dev.hlthtek.com/patient/?org=${orgCode}&patient_id=${patientId}`}
        width="97%"
        height="100%"
        style={{
          border: "none",
          maxWidth: "100%", // Ensures it doesn't exceed parent width
        }}
        title="Patient Analytics"
      />
    </div>
  );
};

export default PatientAnalyticsModal;
